module.exports = __webpack_public_path__ + "static/media/gaara.cc9b8e7e.webp";